import { instance as axiosToken, setJwtToken, setMultiPartHeader } from "../../config/axiosInstance";
import { instance as axios } from "../../config/axiosInstance";
// ---------get-Support-Data-Api-----------------------
export const getSupportDataApi = async (data) => {
    const endPoint = `user/setting` + '?' + new URLSearchParams({ ...data }).toString()
    return await axios.get(endPoint, setJwtToken());
};